import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { generalIcons } from "../../utils/constants";
import { Steps } from "../../components";
import DelegateConnectWallet from "../../components/DelegateConnectWallet";
import { useWalletConnect } from "../../context/wallet-connection";
import TermsAndConditions from "../../components/TermsAndConditions";
import Stake from "../../components/Stake";
import ConfirmStake from "../../components/ConfirmStake";
import { useStakingContext } from "../../context/staking-context";

function Delegate() {
  const { isAuthenticated, address } = useWalletConnect();
  const {
    availableBalance,
    inputValue,
    setInputValue,
    IsFetchingWalletInfo,
    isStakeAmountConfirmed,
    setIsStakeAmountConfirmed,
    isTermsAgreed,
    setIsTermsAgreed,
    isConfirmDisabled,
    setIsConfirmDisabled,
    selectedValidator,
    setBtnloading,
    setIsMaxSelected,
    isMaxSelected,
    setTrxData,
    setTrx,
    btnloading,
    isStakeSuccess,
    setIsStakeSuccess,
    isTrxSuccess,
  } = useStakingContext();

  const navigate = useNavigate()

  useEffect(()=>{
    if(selectedValidator?.contract_address === ""){
      navigate("/all-validator")
    }
  },[selectedValidator])

  useEffect(() => {
    setInputValue("");
    setIsConfirmDisabled(true);
    setIsTermsAgreed(false);
    setIsStakeAmountConfirmed(false);
  }, [
    setInputValue,
    setIsConfirmDisabled,
    setIsTermsAgreed,
    setIsStakeAmountConfirmed,
  ]);

  return (
    <div className="relative min-h-screen h-full pb-16 lg:pb-[100px]">
      <div className="max-w-container px-3 lg:px-[25px] xl:px-[33px] m-auto">
        <div className="flex items-center">
          <Link
            to={"/"}
            className="flex items-center -tracking-08 w-fit text-xsm font-medium text-dim"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 mr-4 *:w-full *:h-full">
              {generalIcons.backArrow}
            </div>
            <span className="opacity-[50%] mr-1">Overview / </span>{" "}
          </Link>
          <span className="text-xsm">Delegate</span>
        </div>
        <div className="mt-11 mb-6 md:mb-[60px]">
          <h1 className="heading text-textcolor font-bold lg:-tracking-37 mb-3">
            Delegate
          </h1>
          <p className="text-sm md:text-base leading-6 md:leading-7 -tracking-1 font-normal text-dim/50">
            Delegate your tokens to a trusted validator and earn rewards.
          </p>
        </div>
        <>
          <Steps
            isAuthenticated={isAuthenticated}
            isStakeAmountConfirmed={isStakeAmountConfirmed}
            isTermsAgreed={isTermsAgreed}
            isUnstake={false}
          />
          {!isAuthenticated && <DelegateConnectWallet />}
          {isAuthenticated && !isStakeAmountConfirmed && (
            <Stake
              availableBalance={availableBalance}
              inputValue={inputValue}
              setInputValue={setInputValue}
              IsFetchingWalletInfo={IsFetchingWalletInfo}
              setIsStakeAmountConfirmed={setIsStakeAmountConfirmed}
              isConfirmDisabled={isConfirmDisabled}
              setIsConfirmDisabled={setIsConfirmDisabled}
              selectedValidator={selectedValidator}
              setIsMaxSelected={setIsMaxSelected}
              isTermsAgreed={isTermsAgreed}
              setIsTermsAgreed={setIsTermsAgreed}
            />
          )}
          {/* {isAuthenticated && isStakeAmountConfirmed && !isTermsAgreed && (
            <TermsAndConditions
              setIsTermsAgreed={setIsTermsAgreed}
              setIsStakeAmountConfirmed={setIsStakeAmountConfirmed}
            />
          )} */}
          {isStakeAmountConfirmed && isTermsAgreed && (
            <ConfirmStake
              availableBalance={availableBalance}
              setIsTermsAgreed={setIsTermsAgreed}
              inputValue={inputValue}
              setInputValue={setInputValue}
              isConfirmDisabled={isConfirmDisabled}
              setIsConfirmDisabled={setIsConfirmDisabled}
              selectedValidator={selectedValidator}
              userWalletAddress={address}
              setBtnloading={setBtnloading}
              isMaxSelected={isMaxSelected}
              setIsMaxSelected={setIsMaxSelected}
              setTrxData={setTrxData}
              setTrx={setTrx}
              setIsStakeAmountConfirmed={setIsStakeAmountConfirmed}
              isStakeAmountConfirmed={isStakeAmountConfirmed}
              btnloading={btnloading}
              isStakeSuccess={isStakeSuccess}
              setIsStakeSuccess={setIsStakeSuccess}
              isTrxSuccess={isTrxSuccess}
            />
          )}
        </>
      </div>
    </div>
  );
}

export default Delegate;
